@if (this.nebularService.CookieAgreement) {
  <div class="row exchanges-frame">
    @for (exch of exchanges; track exch) {
      <nebular-custom-exchange [exchange]="exch"></nebular-custom-exchange>
    }
    @if (!this.uiService.DraggingExchange) {
      <div id="addCustomExchange" class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
        <div id="addExchangeButton" class="exchange-link" (click)="addCustomExchange();">
          (add)
        </div>
      </div>
    }
  </div>
}


<div id="draggedSnapshot" style="position: fixed; z-index: 5;">
  &nbsp;
</div>

@if (!this.nebularService.CookieAgreement) {
  <nebular-cookie-consent></nebular-cookie-consent>
}
